'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _mechvent = require('./mechvent.component');

var _mechvent2 = _interopRequireDefault(_mechvent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mechventModule = _angular2.default.module('mechvent', [_angularUiRouter2.default]).component('mechvent', _mechvent2.default);

exports.default = mechventModule;


// WEBPACK FOOTER //
// ./client/app/common/reports/mechvent/mechvent.js